import { createAction } from 'redux-actions';

export const NAMES = {
  ALL: 'CLIENT.VIDEO_URLS.CLEAR_ALL',
  FOR_ITEM: 'CLIENT.VIDEO_URLS.CLEAR_FOR_ITEM',
};

export const clearVideoUrlsCacheForAll = createAction(NAMES.ALL);
export const clearVideoUrlsCacheForItem = createAction(NAMES.FOR_ITEM);
